import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'

const CertificateFooter = ({ loading, disabled = false }) => {
  const { t, tSafe } = useLocalize()
  const { downloadAfterGenerate, setDownloadAfterGenerate } =
    useCertificateStore()
  const isDisabled = loading || disabled
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-t tw-border-base-300">
      <div className="tw-m-4">
        <CheckboxWithLabelField
          value={downloadAfterGenerate}
          onChange={setDownloadAfterGenerate}
          background={false}
          noPadding
          label={tSafe(
            'attestationForm.download-after-generate',
            'Pobierz zaświadczenie po wygenerowaniu',
          )}
        />
      </div>
      <button
        disabled={isDisabled}
        type="submit"
        title={
          disabled && !loading
            ? 'Wybierz typ zaświadczenia'
            : undefined
        }
        className={`tw-m-4 tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80 ${isDisabled ? 'tw-cursor-not-allowed tw-opacity-50' : 'tw-cursor-pointer'}`}
      >
        {t('operation.confirm')}
      </button>
    </div>
  )
}

export default CertificateFooter
